module.exports = __webpack_public_path__ + "img/pageBanner-meetOurTeam.54f2c51f.jpg";